<script module>
  import img1 from './integrations-1.webp'
  import img2 from './integrations-2.webp'

  export const meta = {
    title: 'Integrations (Slack & Microsoft Teams)',
    teaser:
      'Learn how to setup and use the Slack and Microsoft Teams integrations.',
    sort: 4,
  }
</script>

<p>
  Enhance your team's productivity and stay updated with our easy-to-use
  integrations for Slack and Microsoft Teams. These integrations are designed to
  streamline notifications for your organization, ensuring that your team stays
  informed about new sessions without the need for individual setup.
</p>
<h2>Slack Integration</h2>
<p>
  Available for organizations on the Pausly Plus plan, the Slack integration
  offers a direct channel for receiving updates about new Pausly sessions. This
  feature allows your teams to automatically receive announcements in dedicated
  Slack channels.
</p>
<h3>How to Set It Up</h3>
<p>
  Navigate to the notifications section within your organization's settings.
  After adding the Slack integration, you will be guided through the process of
  linking it with your Pausly account.
</p>
<h3>Features</h3>
<ul>
  <li>
    <strong>Team Channels:</strong> Set up Slack channels that automatically inform
    your team of new sessions.
  </li>
  <li>
    <strong>Individual Notifications:</strong> Team members can opt to receive personal
    notifications for sessions created by their peers.
  </li>
</ul>
<table>
  <thead>
    <tr>
      <th></th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td><img src={img1} alt="Personal notification" /></td>
      <td><img src={img2} alt="Group notification" /></td>
    </tr>
  </tbody>
</table>
<h2>Microsoft Teams Integration</h2>
<p>
  Available for organizations on the Pausly Plus plan, Pausly connects to
  Microsoft Teams through an incoming webhook, posting session notifications
  straight into a Teams channel of your choice. Webhooks are configured per
  team, so each of your Pausly teams can send its notifications to a different
  Teams channel.
</p>
<h3>How to Set It Up</h3>
<ol>
  <li>
    In Microsoft Teams, open the channel you want notifications in and go to its
    Setup page. Under <strong>Connectors → Incoming Webhook</strong>, create a
    webhook and copy the URL it gives you.
  </li>
  <li>
    In Pausly, open the settings page of the team you want to connect, paste the
    URL into the <strong>MS Teams Webhook</strong> field, and save.
  </li>
</ol>
<p>
  From then on, whenever a session starts for that team, a notification is
  posted to the connected Teams channel.
</p>
<p>
  By integrating Pausly with Slack and Microsoft Teams, you can create a more
  connected and informed workspace for your team. These integrations are
  designed to fit seamlessly into your existing communication platforms, making
  it easier than ever to stay aligned and productive.
</p>
